
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 49"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D0EFEC","d":"M14.554 37.096H29.86V42.2H14.554z"}}),_c('path',{attrs:{"fill":"#D0EFEC","fill-rule":"evenodd","d":"M13.558 8.65a.633.633 0 0 0-.633.633v9.711a9.223 9.223 0 0 0 1.266 4.682 9.28 9.28 0 0 0 8.016 4.6 9.28 9.28 0 0 0 9.282-9.282V9.283a.633.633 0 0 0-.633-.633zm11.566 5.508L24 11.431l-1.124 2.727-2.918.236 2.223 1.922-.68 2.873L24 17.649l2.498 1.54-.68-2.873 2.224-1.922z","clip-rule":"evenodd"}}),_c('path',{attrs:{"stroke":"#234652","d":"M21.287 26.024v6.17h-2.012v2.9m9.45 0v-2.9h-2.012v-6.17m6.57-15.448h5.709c-.108 1.37-.437 3.073-1.247 4.637-.867 1.677-2.296 3.22-4.703 4.04m.24-10.922h7.999v1.122c0 1.658-.264 4.321-1.542 6.791-1.305 2.52-3.65 4.8-7.67 5.583h-.052m-17.3-11.251H9.009c.108 1.37.437 3.073 1.247 4.637.867 1.677 2.296 3.22 4.704 4.04m-.247-10.922H6.72v1.122c0 1.658.264 4.321 1.542 6.791 1.305 2.52 3.65 4.8 7.669 5.583h.053m-1.024-2.573a9.3 9.3 0 0 1-.241-2.11v-9.71c0-.35.283-.634.633-.634H32.65c.35 0 .633.284.633.633v9.712a9.3 9.3 0 0 1-.24 2.109m-18.083 0a9.2 9.2 0 0 0 1.024 2.573m0 0a9.28 9.28 0 0 0 8.017 4.6 9.28 9.28 0 0 0 8.017-4.6m0 0a9.2 9.2 0 0 0 1.025-2.573m-16.786 15.84h15.488v5.256H16.256z"}})])
          )
        }
      }
    